export enum BgColor {
    PRIMARY = "bg-primary",
    LIGHT = "bg-light",
    WHITE = "bg-white"
}